import type { RouteRecordRaw } from 'vue-router';

export const inboxRoute: RouteRecordRaw = {
  path: '/chats',
  name: 'ChatsInbox',
  component: () => import('./pages/ChatsInboxPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:bot:chat:list'),
  },
  children: [
    {
      path: 'dashboard',
      redirect: { name: 'Dashboard' },
    },
    {
      path: ':chatId',
      name: 'ChatConversation',
      component: () => import('./pages/ChatsConversationPage.vue'),
      props: true,
      meta: {
        authorize: ({ isGranted }) => isGranted('ugi:bot:chat:read'),
      },
    },
  ],
};

export const dashboardRoute: RouteRecordRaw = {
  path: '/dashboard',
  name: 'Dashboard',
  component: () => import('./pages/ChatsDashboardPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:bot:chat:dashboard'),
  },
};
